import { RoundButton } from '@cian/ui-kit';
import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';

import { clsx } from 'clsx';
import { type FC } from 'react';

import styles from './SeriaPlusCarouselControls.css';

type SeriaPlusCarouselControlsProps = {
  hasMultipleSlides: boolean;
  onNextSlideClick: () => void;
  onPreviousSlideClick: () => void;
};

export const SeriaPlusCarouselControls: FC<SeriaPlusCarouselControlsProps> = props => {
  const { hasMultipleSlides, onNextSlideClick, onPreviousSlideClick } = props;

  return (
    <>
      <div className={clsx(styles['arrow'], styles['arrow--left'])}>
        <RoundButton
          disabled={!hasMultipleSlides}
          data-testid="seria-plus-carousel-arrow-left"
          icon={<IconActionChevronLeft16 />}
          size="M"
          theme="light"
          title="Назад"
          type="button"
          onClick={onPreviousSlideClick}
        />
      </div>
      <div className={clsx(styles['arrow'], styles['arrow--right'])}>
        <RoundButton
          disabled={!hasMultipleSlides}
          data-testid="seria-plus-carousel-arrow-right"
          icon={<IconActionChevronRight16 />}
          size="M"
          theme="light"
          title="Вперёд"
          type="button"
          onClick={onNextSlideClick}
        />
      </div>
    </>
  );
};
